module.exports = __webpack_public_path__ + "assets/c4a3de5948c3534348e8ed75a62eab14.mp3";